import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import isNullOrUndefined from 'scaleflow/utils/isNullOrUndefined';

export default class BackOfANapkinTemplatesInvestmentComponent extends Component {
  @service organisation;

  get ppw() {
    return this.organisation.ppw;
  }

  calculateValue(weeks = 0, people = 0) {
    return (+weeks || 0) * (+people || 0) * this.ppw;
  }

  get valueBeforeConfidence() {
    return this.calculateValue(
      this.args.calculation.weeks,
      this.args.calculation.people,
    );
  }

  @action
  handleChange(e) {
    const calculation = { ...this.args.calculation };
    calculation[e.target.name] = Number(e.target.value);
    calculation.value = this.calculateValue(
      calculation.weeks,
      calculation.people,
    );
    calculation.price_person_week = this.ppw;
    this.args.onValueEmit(calculation);
  }

  @action
  onConfidenceChange(confidence) {
    const calculation = { ...this.args.calculation };
    calculation.confidence_value = confidence.value;
    calculation.confidence_label = confidence.label;
    this.args.onValueEmit(calculation);
  }

  @action
  onRender() {
    this.updateValue();
  }

  updateValue() {
    const finalValue = this.finalValue;
    if (isNaN(finalValue)) return;
    const calculation = { ...this.args.calculation };
    calculation.value = this.valueBeforeConfidence;
    this.args.onValueEmit(calculation);
  }

  get confidenceLabel() {
    // if (this.args.calculation.confidence === undefined) return '-';
    // else return this.organisation.getInvestmentConfidenceLabel(this.args.calculation.confidence);
    return this.args.calculation.confidence_label ?? '-';
  }

  get finalValue() {
    if (
      !isNullOrUndefined(this.args.calculation.confidence_value) &&
      !isNullOrUndefined(this.args.calculation.weeks) &&
      !isNullOrUndefined(this.args.calculation.people)
    )
      return (
        this.valueBeforeConfidence * this.args.calculation.confidence_value
      );
    else return '-';
  }
}
